import { navigate } from "gatsby"

/**
 * Checks if href is external. Supports the following:
 *   mailto:anything
 *   https://anything
 *   ftp://anything
 *   //anything
 *
 * @param href string
 * @returns boolean
 */
export const isExternal = (href: string): boolean =>
  /^(([\w]+:)?\/\/|[\w]+:)[\w]/.test(href)

/**
 * Apply UTM parameters to a URL
 *
 * @param baseUrl string
 * @param source string
 * @param medium string
 * @param campaign string
 * @returns string
 */
export const applyUTMParameters = (
  baseUrl: string,
  source: string,
  medium: string,
  campaign: string,
): string => {
  if (!source || !medium || !campaign) {
    return baseUrl
  }

  const data = {
    utm_source: source,
    utm_medium: medium,
    utm_campaign: campaign,
  }

  const searchParams = new URLSearchParams(data)

  return `${baseUrl}?${searchParams}`
}

export const handleFauxClick: React.MouseEventHandler<HTMLElement> = e => {
  if ((e.target as HTMLElement).tagName !== "A") {
    const currentTarget = e.currentTarget as HTMLElement
    // Check if we have any link in the element, if so, we click that programmaticly for tracking purposes
    const link: HTMLAnchorElement = currentTarget.getElementsByTagName("a")[0]
    if (link && link.href) {
      link.click()
    } else {
      const href = currentTarget.getAttribute("data-faux-href")
      if (href) {
        if (isExternal(href)) {
          window.open(href, "_blank")
        } else {
          navigate(href)
        }
      }
    }
  }
}
